var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"footer","fluid":""}},[_vm._v(" Created and maintained by Rebecca Palmore "),_c('b-link',{attrs:{"target":"_blank","href":"https://github.com/rpalmore/babygreen"}},[_c('b-avatar',{staticClass:"avatar-icon-github",attrs:{"icon":"github"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }